import { Page } from '../types';

export const pages: Page[] = [
  {
    path: '/',
    title: 'FERAL-AUD.IO',
    description:
      'GORILLA and other professional iOS synthesizers and audio software. Powerful, precise, and professional sound design tools for your mobile studio.',
    ogImage: '/assets/images/og-home.png',
  },
  {
    path: '/products/chordpond',
    title: 'CHORDPOND - FERAL-AUD.IO',
    description:
      'Explore 200+ chord progressions, shape harmony and rhythm, and build songs with visual chord paths in CHORDPOND for iPad, iPhone, and Mac.',
    ogImage: '/assets/images/og-home.png',
  },
  {
    path: '/privacy',
    title: 'Privacy Policy - FERAL-AUD.IO',
    description: 'Privacy policy for FERAL-AUD.IO iOS applications',
    ogImage: '/assets/images/og-home.png',
  },
];

export const getPageMeta = (path: string): Page | undefined => {
  return pages.find((page) => page.path === path);
};
